import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

import easing from 'ui/styles/easing'
import IconCircledArrow from 'ui/components/generic/IconCircledArrow'
import FlexibleLink from 'ui/components/generic/FlexibleLink'


const Wrapper = styled(FlexibleLink)`
  /* Reset */
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  text-align: inherit;

  background: transparent;

  /* inherit font & color from ancestor */
  color: inherit;
  font: inherit;

  /* Normalize \`line-height\`. Cannot be changed from \`normal\` in Firefox 4+. */
  line-height: normal;

  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;

  /* Corrects inability to style clickable \`input\` types in iOS */
  -webkit-appearance: none;

  background: ${props => props.look === 'orange' ? props.theme.colors.primaryDarker : props.theme.colors.secondaryDark};
  padding: 12px 22px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  color: ${props => props.look === 'orange' ? props.theme.colors.secondary : props.theme.colors.text};
  transition: color 0.3s ${easing.easeOutCubic}, background 0.3s ${easing.easeOutCubic};
  font-weight: ${props => props.theme.fontWeights.medium};

  &:hover {
    color: white;
    background: ${props => props.look === 'orange' ? props.theme.colors.primaryDarkest : props.theme.colors.primary};
  }
`

const ButtonText = styled.span`
  margin-right: 2.5em;

  ${media.md`
    margin-right: 4em;
  `}

  ${media.lg`
    margin-right: 7em;
  `}
`

export default class Button extends Component {
  state = { hover: false }
  render() {
    const {
      link,
      title,
      target,
      look,
      component
    } = this.props

    const { hover } = this.state

    return (
      <Wrapper
        as={component || undefined }
        href={link}
        target={target}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        look={look}
      >
        <ButtonText>{title}</ButtonText>
        <IconCircledArrow
          hover={hover}
          look={look}
        />
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/generic/Button.js